import { CollectionsLobbyMixpanelEvents } from '../../../../../page/collections_lobby/utils/events/mixpanel';
import { CollectionPageMixpanelEvents } from '../../../../../page/collection_page/utils/events/mixpanel';
import { EventTypes } from '../../types';
import { createMixpanelEvent } from './base';

const { modals, collection } = EventTypes.shared;
const { shareWithTeam, socialShare, deleteConfirmation, editCollection } = modals;

export const MixpanelEvents = {
    ...CollectionsLobbyMixpanelEvents,
    ...CollectionPageMixpanelEvents,

    [shareWithTeam.show]: createMixpanelEvent('Share With Team Modal - show'),
    [shareWithTeam.cancel]: createMixpanelEvent('Share With Team Modal - cancel'),
    [shareWithTeam.submit]: createMixpanelEvent('Share With Team Modal - submit'),
    [shareWithTeam.fail]: createMixpanelEvent('Share With Team Modal - fail'),

    [socialShare.show]: createMixpanelEvent('Social Sharing Modal - show'),

    [deleteConfirmation.show]: createMixpanelEvent('Delete Confirmation Modal - show'),
    [deleteConfirmation.cancel]: createMixpanelEvent('Delete Confirmation Modal - cancel'),
    [deleteConfirmation.submit]: createMixpanelEvent('Delete Confirmation Modal - submit'),
    [deleteConfirmation.fail]: createMixpanelEvent('Delete Confirmation Modal - fail'),

    [editCollection.show]: createMixpanelEvent('Edit Collection Modal - show'),
    [editCollection.cancel]: createMixpanelEvent('Edit Collection Modal - cancel'),
    [editCollection.submit]: createMixpanelEvent('Edit Collection Modal - submit'),
    [editCollection.fail]: createMixpanelEvent('Edit Collection Modal - fail'),

    [collection.create.success]: createMixpanelEvent('Collection created'),
    [collection.update.success]: createMixpanelEvent('Collection updated'),
    [collection.delete.success]: createMixpanelEvent('Collection deleted'),
    [collection.shareWithTeam.success]: createMixpanelEvent('Collection shared with team'),
};
